import React, {useMemo} from 'react';
import {AddCardProps} from "../../types/types";
import classes from "./AddCard.module.css";
import {RAIL_VIEW} from "../../consts/viewType";
import {triggerEvent} from "../../utils/eventRegistry";

const AddCard: React.FC<AddCardProps> = (props) => {

    const handleButtonClick = () => {
        triggerEvent('OnAddCard');
    };

    const config = useMemo(()=>{
        return props.config;
    },[props.config])


    const cardStyle = useMemo(()=>{
        if(props.config.viewType === RAIL_VIEW){
            return {
                height: '80px',
                width: config.railCardWidth ? config.railCardWidth + 'px': '100%'
            }
        }else{
            return {
                height: config.tileCardHeight ? config.tileCardHeight + 'px': '200px',
                width: '100px'
            }
        }
    },[props.config.viewType, config.railCardWidth, config.tileCardHeight])


    return (
        <div className={classes.addCard} style={cardStyle} onClick={handleButtonClick}>
            +
        </div>
    );
};

export default AddCard;